<template>
    <div class="menus__component">
        <div :class="isB2b ? 'content' : 'content-b2c'">
            <div
                v-for="item in availableModules"
                :key="item.moduleName"
                style="position: relative"
            >
                <template v-if="item.isVisible">
                    <a
                        @click="clickMenuItem(item)"
                        class="title-url-link m-1"
                        :class="menuClass(item)"
                        style="cursor: pointer"
                        :id="
                            item.moduleId +
                            '_' +
                            item.moduleName.replace(/\s/g, '_')
                        "
                    >
                        <div
                            v-if="item.notificationCount > 0"
                            class="notification--count"
                        >
                            <span class="notification--text">{{
                                item.notificationCount
                            }}</span>
                        </div>
                        <img
                            :src="item.iconSidebar"
                            class="mr-2"
                            onload="SVGInject(this)"
                            width="12%"
                            :class="item.route + item.moduleId"
                        />

                        <p>{{ item.moduleName }}</p>

                        <svg
                            @click="$emit('click-tooltip', item)"
                            v-if="!item.isActive && item.hasTooltip"
                            class="info-cls"
                            style="position: absolute; right: 20"
                            xmlns="http://www.w3.org/2000/svg"
                            width="9%"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <g
                                id="Grupo_4757"
                                data-name="Grupo 4757"
                                transform="translate(-1750 -372)"
                            >
                                <g
                                    id="Componente_7_1"
                                    data-name="Componente 7 – 1"
                                    transform="translate(1750 372)"
                                >
                                    <circle
                                        id="Elipse_732"
                                        data-name="Elipse 732"
                                        cx="12"
                                        cy="12"
                                        r="12"
                                        :stroke="primaryColorByDomain"
                                        :fill="primaryColorByDomain"
                                    />
                                </g>
                                <path
                                    id="Path_4519"
                                    data-name="Path 4519"
                                    d="M12.689,7.976A.687.687,0,0,1,11.9,7.4a.7.7,0,0,1,0-.194,1.066,1.066,0,0,1,.229-.714.763.763,0,0,1,.612-.27.689.689,0,0,1,.784.578.664.664,0,0,1,0,.194,1.02,1.02,0,0,1-.236.728A.8.8,0,0,1,12.689,7.976Zm-2.27,1.989.123-.588h2.509l-.95,4.5a8.04,8.04,0,0,0-.212,1.552q0,.711.465.711a2.072,2.072,0,0,0,1-.362l.253.41a2.948,2.948,0,0,1-1.894.834,1.051,1.051,0,0,1-.841-.376,1.414,1.414,0,0,1-.321-.952,13.266,13.266,0,0,1,.314-2.2l.54-2.57a1.913,1.913,0,0,0,.048-.369q0-.588-.854-.588Z"
                                    transform="translate(1750.581 371.782)"
                                    fill="#fff"
                                />
                            </g>
                        </svg>
                    </a>
                </template>
            </div>
        </div>

        <vehicle-search-component
            :show="modal.show"
            :mode="2"
            @modal-closed="modalClosed"
        />
    </div>
</template>

<script>
import mixinMenus from "@mixins/b2b/menus.js";

export default {
    mixins: [mixinMenus],
    computed: {
        isB2b() {
            return this.$store.getters["auth/getState"].isB2B;
        },
        primaryColorByDomain() {
            return this.$store.getters["domain/getStateDomainData"]
                .primaryColorHex;
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

.menus__component {
    .notification--count {
        position: absolute;
        font-size: 12px;
        font-family: Lato;
        right: 0px;
        top: -5px;
        background: #f59534;
        color: $white;
        width: 20px;
        height: 20px;
        text-align: center;
        vertical-align: middle;
        border-radius: 50%;
        padding: 1px;
        transition: ease $animations-time-duration;
    }

    .content {
        padding: 15px;
        .disabled-a {
            /* opacity: 0.5; */
            p {
                opacity: 0.5;
            }
            svg {
                opacity: 0.5;
            }
            &:hover {
                background-color: var(--v-primary-lighten3) !important;
                color: white !important;
            }
            span {
                opacity: 1;
            }
        }
        a {
            font-family: Lato;
            display: flex;
            align-items: center;
            padding: 15px 10px;
            margin: 10px 0;
            border-radius: 7.5px;
            text-decoration: none;
            color: $grey-dark;
            transition: $animations-time-duration ease;
            max-height: 45px !important;
            min-height: 45px !important;

            .notification--text {
                justify-content: center;
                padding: 0 !important;
                margin: 0 !important;
                max-width: 20px !important;
                max-height: 20px !important;
                min-height: 20px !important;
                color: $white;
                opacity: 1;
            }

            &:hover {
                background-color: var(--v-primary-lighten1) !important;
                color: #fff !important;
                text-decoration: none;

                svg {
                    g,
                    path:last-child {
                        fill: #fff;
                    }
                }

                // SVG ESTIMAR-REMARACAO.SVG
                #budget2 {
                    .estimate-repair-svg2 {
                        fill: #fff !important;
                    }
                }

                #tech-info4 {
                    path {
                        stroke: white !important;
                    }
                }

                #planning15 {
                    g {
                        g {
                            path,
                            line,
                            polyline {
                                stroke: #fff !important;
                            }
                        }
                    }
                }

                #environmental8 {
                    g {
                        g {
                            path {
                                stroke: #fff !important;
                            }
                        }
                    }
                }

                #marketing17 {
                    polyline {
                        stroke: #fff !important;
                    }
                }

                #dsb_icon_peq {
                    path {
                        fill: #fff !important;
                        .cls-1 {
                            fill: #fff !important;
                        }
                        g {
                            .cls-1 {
                                fill: #fff !important;
                            }
                        }
                    }
                }

                #strema_cls_svg {
                    .strema-cls-1 {
                        fill: #fff !important;
                    }
                }
            }

            span {
                margin-right: 5px;
            }

            p {
                margin: 0;
            }

            &.router-link-exact-active.router-link-active {
                background-color: var(--v-primary-base) !important;
                color: $white;

                svg {
                    g,
                    path:last-child {
                        fill: $white;
                    }
                }
            }
        }

        span {
            font-family: Lato;
            display: flex;
            align-items: center;
            padding: 15px 10px;
            margin: 10px 0;
            border-radius: 7.5px;
            text-decoration: none;
            color: $grey-dark;
            transition: $animations-time-duration ease;
            opacity: 0.5;
            max-height: 45px !important;
            min-height: 45px !important;

            .notification--text {
                justify-content: center;
                padding: 0 !important;
                margin: 0 !important;
                max-width: 20px !important;
                max-height: 20px !important;
                min-height: 20px !important;
                color: $white;
                opacity: 1;
            }

            span {
                margin-right: 5px;
            }

            p {
                margin: 0;
            }
            &:hover {
                opacity: 1;
            }
        }
    }

    .content:last-child {
        margin-bottom: 36px;
    }

    .title-url-link {
        &:hover {
            color: $white;
            text-decoration: none;

            svg {
                g,
                path:last-child {
                    fill: $white;
                }
            }
        }
    }

    .content-b2c {
        padding: 15px;

        a {
            font-family: Lato;
            display: flex;
            align-items: center;
            padding: 15px 10px;
            margin: 10px 0;
            border-radius: 7.5px;
            text-decoration: none;
            color: $grey-dark;
            transition: $animations-time-duration ease;

            &:hover {
                background-color: $filinto-blue;
                color: var(--v-yellow-base);
                text-decoration: none;
            }

            span {
                margin-right: 5px;
            }

            p {
                margin: 0;
            }

            &.router-link-exact-active.router-link-active {
                background-color: var(--v-yellow-base);
                color: $filinto-blue;
            }
        }
    }
    .not-click {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        cursor: pointer;
    }

    .router-link-exact-active.router-link-active {
        // SVG ORCAMENTO.SVG
        /* #budget2 {
      text {
        fill: white !important;
      }
      .path1,
      .path3,
      .path5 {
        stroke: white !important;
      }
      .path2,
      .path4 {
        fill: white !important;
      }
      polyline {
        stroke: white !important;
      }
      line {
        stroke: white !important;
      }
    } */

        // SVG ESTIMAR-REPARACAO.SVG
        #budget2 {
            .estimate-repair-svg2 {
                fill: #fff !important;
            }
        }
        
        #webshop7 {
            .webshop-svg {
                stroke: #fff !important;
            }
        }

        #tech-info4 {
            path {
                stroke: white !important;
            }
        }
        #planning15 {
            g {
                g {
                    path,
                    line,
                    polyline {
                        stroke: #fff !important;
                    }
                }
            }
        }
        #environmental8 {
            g {
                g {
                    path {
                        stroke: #fff !important;
                    }
                }
            }
        }

        #active-reception6 {
            g {
                g {
                    path {
                        stroke: #fff !important;
                    }
                }
            }
        }
    }

    .title-url-link {
        &:hover {
            svg {
                path {
                    stroke: #fff !important;
                }
                g {
                    circle {
                        stroke: #fff !important;
                    }
                }
                .estimate-repair-svg2 {
                    stroke: transparent !important;
                }
                .strema-cls-1 {
                    stroke: transparent !important;
                }
            }
            .info-cls {
                opacity: 1 !important;
                circle {
                    stroke: var(--v-primary-base) !important;
                }
            }
        }
    }

    .info-cls {
        opacity: 0 !important;
    }

    .strema-cls {
        opacity: 1 !important;
        &:hover {
            background-color: var(--v-primary-base) !important;
            color: $white;
            text-decoration: none;

            svg {
                g,
                path:last-child {
                    fill: $white;
                }
            }

            svg {
                path {
                    fill: $white !important;
                }
            }
        }
    }

    .strema-cls-1 {
        opacity: 1 !important;
        &:hover {
            background-color: var(--v-primary-base) !important;
            color: $white;
            text-decoration: none;
            fill: $white !important;

            svg {
                g,
                path:last-child {
                    fill: $white;
                }
            }
        }
    }
}
</style>
